/*
 * action types
 */
export const STUDENT = 'STUDENT'
export const CHECKED = 'CHECKED'

/*
 * action creators
 */

export function setSelectedStudent(payload) {
  return {
    payload,
    type: STUDENT,
  }
}
export function setIfStudentHaveChecked(payload) {
  return {
    payload,
    type: CHECKED,
  }
}
